import { TableList, Typography } from 'seagull';
import ViewInvoice from "../components/ViewInvoice/ViewInvoice";
import VendorNameLink from "../components/VendorNameLink/VendorNameLink";
import { RequiresApproval } from "./types";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const FutureInvoiceRow = _ref => {
  let {
    testId,
    futureInvoice
  } = _ref;
  const displayedAgreementName = futureInvoice.displayedAgreementName();
  const items = [{
    value: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(VendorNameLink, {
        testid: "".concat(testId, "-company-name"),
        vendorName: futureInvoice.companyName(),
        relationshipID: futureInvoice.relationshipId()
      }), displayedAgreementName && /*#__PURE__*/_jsx(Typography, {
        skin: "secondary",
        "data-testid": "".concat(testId, "-agreement-name"),
        ellipsis: true,
        children: displayedAgreementName
      })]
    })
  }, {
    value: /*#__PURE__*/_jsx(Typography, {
      "data-testid": "".concat(testId, "-issue-date"),
      children: futureInvoice.issueDate()
    })
  }, {
    value: /*#__PURE__*/_jsx(Typography, {
      "data-testid": "".concat(testId, "-due-date"),
      children: futureInvoice.dueDate()
    })
  }, {
    value: /*#__PURE__*/_jsx(Typography, {
      "data-testid": "".concat(testId, "-requires-approval"),
      children: futureInvoice.requiresApproval() ? RequiresApproval.Yes : RequiresApproval.No
    })
  }, {
    value: /*#__PURE__*/_jsx(Typography, {
      "data-testid": "".concat(testId, "-total"),
      children: futureInvoice.total()
    })
  }, {
    value: /*#__PURE__*/_jsx(ViewInvoice, {
      relationshipID: futureInvoice.relationshipId(),
      date: futureInvoice.rawIssueDate(),
      testid: "".concat(testId, "-view-invoice")
    })
  }];
  return /*#__PURE__*/_jsx(TableList.Row, {
    "data-testid": testId,
    items: items
  });
};
export default FutureInvoiceRow;